import React, { Component } from 'react';
import FormWrapper from '../../../containers/Forms/FormWrapper';
import FormVerificationCode from '../../../containers/Forms/FormVerificationCode';
import { entityNames } from '../../../config/constants';

class Stage2 extends Component {
  componentDidMount() {
    const { fetchReset } = this.props;
    if (fetchReset) {
      fetchReset(entityNames.VERIFY_PASSWORD_RESET_CODE);
    }
  }

  render() {
    const { t, verifyPasswordResetCode } = this.props;
    return (
      <div className="reset-stage">
        <h2 className="reset-stage-title">{t('resetPassword:enterVerificationCode')}</h2>
        <FormWrapper
          entityName={entityNames.VERIFY_PASSWORD_RESET_CODE}
          entity={['phone', 'code']}
          onSubmit={verifyPasswordResetCode}
          noValidation={true}
        >
          <FormVerificationCode />
        </FormWrapper>
      </div>
    );
  }
}

export default Stage2;
